import { createColumnInput, createColumnInputNumber } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import moment from "moment";
import { createFieldDate } from "../../../../components/input/template-builder/template-builder.logic";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.ktb.reqCommand"),
            dataIndex: "reqCommand",
            align: "center",
            width: 100
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.ktb.reqBankCode"),
            dataIndex: "reqBankCode",
            align: "center",
            width: 80
        }),
        createColumnInput({
            title: () => i18n.global.t("model.ktb.reqBankRef"),
            dataIndex: "reqBankRef",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.ktb.reqDateTime"),
            dataIndex: "reqDateTime",
            dataIndexValue: ({ record }) => record?.reqDateTime ? `${moment(record.reqDateTime, "YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm:ss")}` : null,
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "center",
            width: 160,
            search: {
                field: createFieldDate({
                    colProp: () => ({ xs: 24, md: 12 }),
                    label: () => () => i18n.global.t("model.ktb.info.reqDate"),
                    inputProp: ({ field }) => {
                        return {
                            value: field.searchValue ? moment(field.searchValue, "YYYYMMDD").format("YYYY-MM-DD") : null,
                            "onUpdate:value": value => (field.searchValue = value?.replaceAll("-", "")),
                        };
                    }
                }),
                name: "reqDateTime",
                type: "String",
                operator: "like"
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.ktb.reqRef1"),
            dataIndex: "reqRef1",
            align: "center",
            width: 130
        }),
        createColumnInput({
            title: () => i18n.global.t("model.ktb.reqRef2"),
            dataIndex: "reqRef2",
            align: "center",
            width: 130
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.ktb.reqAmount"),
            dataIndex: "reqAmount",
            align: "center",
            allowPrecision: true,
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t("model.ktb.reqCusName"),
            dataIndex: "reqCusName",
            align: "center"
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.ktb.resRespCode"),
            dataIndex: "resRespCode",
            align: "center",
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t("model.ktb.resRespMsg"),
            dataIndex: "resRespMsg",
            align: "center",
            width: 200
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
